import RegisterContainer from './register_container';

const Register = RegisterContainer;
export default Register;
